<template>
  <div class="cover">
    <div v-if="isLoading" class="loading">
      <span style="margin-right: 5px">loading</span>
      <i
        style="font-size: 18px"
        class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
      ></i>
    </div>
    <div class="item">
      <div>
        <p class="text">{{ name }}</p>
        <p class="desc">{{ desc }}</p>
      </div>

      <!-- action buttons -->
      <div class="button-div">
        <button
          @click="enableSetting"
          type="button"
          class="item-button item-button--enable"
        >
          Enable
        </button>
        <button
          @click="disableSetting"
          type="button"
          class="item-button item-button--disable"
        >
          Disable
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Notification } from "element-ui";

export default {
  name: "ElementControlNew", //name should change to ElementControlSwitch
  props: {
    name: "",
    enableAction: null,
    disableAction: null,
    desc: ""
  },
  components: {},
  data() {
    return {
      isLoading: false
    };
  },
  watch: {
    defaultValue: {}
  },
  methods: {
    enableSetting() {
      if (!this.showConfirm("ON")) return;
      this.sendRequest(this.enableAction);
    },
    disableSetting() {
      if (!this.showConfirm("OFF")) return;
      this.sendRequest(this.disableAction);
    },
    sendRequest(action) {
      var requestParam = {
        topic: this.$route.params.deviceId,
        payload: JSON.stringify({
          invConfig: action
        })
      };

      const HTTP = this.$httpUtils.instance;

      this.showLoading(true);
      HTTP.options(
        `${this.$utilConstants.IOT_BASE_URL}/event/publish/`,
        requestParam
      )
        .then(response => {
          this.$emit("refresh");
          this.showAlarm({ type: "success", message: "Success, sent!" });
          this.showLoading(false);
        })
        .catch(e => {
          this.showAlarm({
            type: "error",
            message: "Error, unable to complete action, please try again"
          });
          this.showLoading(false);
        });

      // return HTTP.post(endpoint, requestParam)
    },
    showConfirm(status) {
      return confirm(`Are you sure turn setting ${status}?`);
    },
    showLoading(value) {
      this.isLoading = value;
    },
    // this should be a global something
    showAlarm({ type, message }) {
      console.log(type, message);
      switch (type) {
        case "success":
          return Notification.success({
            title: "Success",
            dangerouslyUseHTMLString: true,
            message: message ? message : "Action completed successfully"
          });

        case "warning":
          return Notification.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: message
          });
        default:
          return Notification.warning({
            title: "Unknown",
            dangerouslyUseHTMLString: true,
            message: message ? message : "unknown, please verify"
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
}

.item {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f4f4f4;
  padding: 10px 0;
  align-items: center;
}

.item-button {
  border: none;
  padding: 0.2em 0.6em 0.3em;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  color: white;
  margin-left: 10px;

  &--enable {
    background: #5cb85c;
  }

  &--disable {
    background: #d9534f;
  }
}

.button-div {
  display: flex;
  align-items: center;
}

.text {
  font-size: 16px;
  font-weight: bold;
}

.desc {
  color: #999;
}

.loading {
  display: flex;
  text-align: center;
  background: #ffffffe6;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/element-control-new.vue